import { Icon } from "@iconify/react";
import { Sidebar } from "../components/Sidebar";
import { useAuth } from "../hooks/useAuth";
import { Layout, Main, TopBar, UserRole } from "../styles/OverviewStyle";

interface DashboardProps {
   children: React.ReactNode;
   title: string;
   icon: string;
   active: string;
}

const Dashboard = ({ children, title, icon, active }: DashboardProps): React.JSX.Element => {
   const { user } = useAuth();

   const getInitials = (fullName: string): string => {
      return fullName
         .split(' ')
         .map(name => name[0])
         .join('')
         .toUpperCase()
         .slice(0, 2);
   };

   const formatRole = (role: string): string => {
      return role.charAt(0).toUpperCase() + role.slice(1);
   };
   const parts = title.split('/').map(s => s.trim()).filter(Boolean);

   return (
      <Layout>
         <Sidebar active={active} />

         <Main>
            <TopBar>
               <div className="flex items-center gap-3">
                  <Icon icon={icon} width={18} />
                  <span className="text-xs">
                     <span className="text-[#101018]">{parts[0]}</span>
                     {parts.slice(1).map((p, i) => (
                        <span key={i} className="text-[#6D6D72]"> / {p}</span>
                     ))}
                  </span>
               </div>

               <div className='flex items-center gap-7'>
                  <Icon icon='ri:global-line' color='#6D6D72' width={18} />
                  <span className='text-[#858589] text-sm font-medium p-1.5 px-2 bg-[#F6F6F6] rounded-full'>
                     {user?.fullName ? getInitials(user.fullName) : 'NA'}
                  </span>
                  <div className="flex flex-col gap-1">
                     <span className='text-xs text-[#101018]'>{user?.username || user?.emailAddress || 'N/A'}</span>
                     <UserRole className="leading-none">{user?.role ? formatRole(user.role) : 'N/A'}</UserRole>
                  </div>
               </div>
            </TopBar>

            {children}
         </Main>
      </Layout>
   )
}

export default Dashboard;